export var DateTime;
(function (DateTime) {
    let Format;
    (function (Format) {
        Format["ISO8601"] = "ISO8601";
    })(Format = DateTime.Format || (DateTime.Format = {}));
    let Unit;
    (function (Unit) {
        Unit["Year"] = "YEAR";
        Unit["Quarter"] = "QUARTER";
        Unit["Month"] = "MONTH";
        Unit["Week"] = "WEEK";
        Unit["DayOfYear"] = "DAYOFYEAR";
        Unit["Day"] = "DAY";
        Unit["Weekday"] = "WEEKDAY";
        Unit["Hour"] = "HOUR";
        Unit["Minute"] = "MINUTE";
        Unit["Second"] = "SECOND";
    })(Unit = DateTime.Unit || (DateTime.Unit = {}));
    DateTime.validUnits = [
        "YEAR",
        "QUARTER",
        "MONTH",
        "WEEK",
        "DAYOFYEAR",
        "DAY",
        "WEEKDAY",
        "HOUR",
        "MINUTE",
        "SECOND",
    ];
    function unit(part) {
        if (typeof part === 'string') {
            switch (part.toUpperCase()) {
                case "YEAR":
                    return "YEAR";
                case "QUARTER":
                    return "QUARTER";
                case "MONTH":
                    return "MONTH";
                case "WEEK":
                    return "WEEK";
                case "DAYOFYEAR":
                    return "DAYOFYEAR";
                case "DAY":
                    return "DAY";
                case "WEEKDAY":
                    return "WEEKDAY";
                case "HOUR":
                    return "HOUR";
                case "MINUTE":
                    return "MINUTE";
                case "SECOND":
                    return "SECOND";
            }
        }
        return null;
    }
    DateTime.unit = unit;
    let TimeUnit;
    (function (TimeUnit) {
        TimeUnit["Second"] = "SECOND";
        TimeUnit["Millis"] = "MILLIS";
        TimeUnit["Micros"] = "MICROS";
    })(TimeUnit = DateTime.TimeUnit || (DateTime.TimeUnit = {}));
    DateTime.validTimeUnits = [
        "SECOND",
        "MILLIS",
        "MICROS",
    ];
    function timeUnit(part) {
        if (typeof part === 'string') {
            switch (part.toUpperCase()) {
                case "SECOND":
                    return "SECOND";
                case "MILLIS":
                    return "MILLIS";
                case "MICROS":
                    return "MICROS";
            }
        }
        return null;
    }
    DateTime.timeUnit = timeUnit;
    let WeekStart;
    (function (WeekStart) {
        WeekStart["Sunday"] = "SUNDAY";
        WeekStart["Monday"] = "MONDAY";
        WeekStart["Tuesday"] = "TUESDAY";
        WeekStart["Wednesday"] = "WEDNESDAY";
        WeekStart["Thursday"] = "THURSDAY";
        WeekStart["Friday"] = "FRIDAY";
        WeekStart["Saturday"] = "SATURDAY";
    })(WeekStart = DateTime.WeekStart || (DateTime.WeekStart = {}));
    DateTime.validWeekStarts = [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
    ];
    function weekStart(start) {
        if (typeof start === 'string') {
            start = start.toUpperCase();
            switch (start) {
                case "SUNDAY":
                case "MONDAY":
                case "TUESDAY":
                case "WEDNESDAY":
                case "THURSDAY":
                case "FRIDAY":
                case "SATURDAY": {
                    return start;
                }
            }
        }
        if (isInt(start)) {
            if (inRange(start, 0, 6)) {
                return DateTime.validWeekStarts[start];
            }
        }
        return undefined;
    }
    DateTime.weekStart = weekStart;
    function weekStartDow(start) {
        if (typeof start === 'string') {
            switch (start.toUpperCase()) {
                case "SUNDAY":
                    return 0;
                case "MONDAY":
                    return 1;
                case "TUESDAY":
                    return 2;
                case "WEDNESDAY":
                    return 3;
                case "THURSDAY":
                    return 4;
                case "FRIDAY":
                    return 5;
                case "SATURDAY":
                    return 6;
            }
        }
        if (isInt(start)) {
            if (inRange(start, 0, 6)) {
                return start;
            }
        }
        return undefined;
    }
    DateTime.weekStartDow = weekStartDow;
    let YearStart;
    (function (YearStart) {
        YearStart["January"] = "JANUARY";
        YearStart["February"] = "FEBRUARY";
        YearStart["March"] = "MARCH";
        YearStart["April"] = "APRIL";
        YearStart["May"] = "MAY";
        YearStart["June"] = "JUNE";
        YearStart["July"] = "JULY";
        YearStart["August"] = "AUGUST";
        YearStart["September"] = "SEPTEMBER";
        YearStart["October"] = "OCTOBER";
        YearStart["November"] = "NOVEMBER";
        YearStart["December"] = "DECEMBER";
    })(YearStart = DateTime.YearStart || (DateTime.YearStart = {}));
    DateTime.validYearStarts = [
        "JANUARY",
        "FEBRUARY",
        "MARCH",
        "APRIL",
        "MAY",
        "JUNE",
        "JULY",
        "AUGUST",
        "SEPTEMBER",
        "OCTOBER",
        "NOVEMBER",
        "DECEMBER",
    ];
    function yearStart(start) {
        if (typeof start === 'string') {
            start = start.toUpperCase();
            switch (start) {
                case "JANUARY":
                case "FEBRUARY":
                case "MARCH":
                case "APRIL":
                case "MAY":
                case "JUNE":
                case "JULY":
                case "AUGUST":
                case "SEPTEMBER":
                case "OCTOBER":
                case "NOVEMBER":
                case "DECEMBER": {
                    return start;
                }
            }
        }
        if (isInt(start)) {
            if (inRange(start, 1, 12)) {
                return DateTime.validYearStarts[start - 1];
            }
        }
        return undefined;
    }
    DateTime.yearStart = yearStart;
    function yearStartMonth(start) {
        if (typeof start === 'string') {
            switch (start.toUpperCase()) {
                case "JANUARY":
                    return 1;
                case "FEBRUARY":
                    return 2;
                case "MARCH":
                    return 3;
                case "APRIL":
                    return 4;
                case "MAY":
                    return 5;
                case "JUNE":
                    return 6;
                case "JULY":
                    return 7;
                case "AUGUST":
                    return 8;
                case "SEPTEMBER":
                    return 9;
                case "OCTOBER":
                    return 10;
                case "NOVEMBER":
                    return 11;
                case "DECEMBER":
                    return 12;
            }
        }
        if (isInt(start)) {
            if (inRange(start, 1, 12)) {
                return start;
            }
        }
        return undefined;
    }
    DateTime.yearStartMonth = yearStartMonth;
})(DateTime || (DateTime = {}));
function isInt(n) {
    return Number.isInteger(n);
}
function inRange(n, lo, hi) {
    return n >= lo && n <= hi;
}
